const HorizontalLine = ({ className = '' }: { className?: string }) => (
  <hr className={`w-full border-concrete ${className}`} />
);

export default HorizontalLine;
